module.exports = __webpack_public_path__ + "img/green54.cb33a545.svg";